import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';

export default class Header extends BaseComp.default {
	renderPersistentButton() {
		const base = super.renderPersistentButton();
		//const cta = base.children[0].attributes.content;
		//if (cta === 'Get Tickets') {
		const method = (e) => {
			const selectedFormat = Store.get().selectedFormat;
			if (selectedFormat) {
				const currentUrl = new URL(window.location);
				if (selectedFormat === 'largeFormat') {
					currentUrl.searchParams.set('format', '4DX,DBOX');
				} else {
					currentUrl.searchParams.set('format', selectedFormat);
				}
				window.history.pushState({}, '', currentUrl);
			}
			this.onClick(e);
		};
		base.children[0].attributes.onClickCapture = method;
		//}
		return base;
	}
}
